module.exports = __webpack_public_path__ + "static/tamagawa-472e2228c7cf5533453c167714fca2b8.jpg";